import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './tr';

i18next 
// pass the i18n instance to react-i18next.
.use(initReactI18next)
.init({
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  lng: 'en', //en, zh
  resources: {
    en: {
      translation: {...tr.en}
    },
    zh: {
      translation: {...tr.zh}
    }
  }
});

export default i18next;
